__turbopack_context__.v({
  "canvas": "WeightRipples-module__iZ-r5G__canvas",
  "cssRing": "WeightRipples-module__iZ-r5G__cssRing",
  "cssRingAnimated": "WeightRipples-module__iZ-r5G__cssRingAnimated",
  "rippleOut": "WeightRipples-module__iZ-r5G__rippleOut",
  "root": "WeightRipples-module__iZ-r5G__root",
  "wrap": "WeightRipples-module__iZ-r5G__wrap",
});
